import { render, staticRenderFns } from "./TipTapBubbleMenu.vue?vue&type=template&id=8a4ad19a&scoped=true&"
import script from "./TipTapBubbleMenu.vue?vue&type=script&lang=js&"
export * from "./TipTapBubbleMenu.vue?vue&type=script&lang=js&"
import style0 from "./TipTapBubbleMenu.vue?vue&type=style&index=0&id=8a4ad19a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4ad19a",
  null
  
)

export default component.exports